import { Badge } from "@devhop/ui";
import type { ReactNode } from "react";
import type { ClassSessionDTO } from "../../domain/contracts/sessions";

/** Room id ສຳລັບປະສານຄລາດສ໌ນອກສະຖານທີ່ໃນ timetable (column ເດີ່ວ) */
export const CLASS_SESSION_OFF_SITE_TIMETABLE_ROOM_ID = "__class_off_site__";

export function formatSessionPlace(
  s: Pick<ClassSessionDTO, "locationKind" | "offSiteLabel" | "roomName">,
): string {
  if (s.locationKind === "off_site") {
    const t = s.offSiteLabel?.trim();
    return t ? `ນອກ: ${t}` : "ນອກສະຖານທີ່";
  }
  return s.roomName || "—";
}

/** ຫົວຂໍ້ຄວາມ event ປະຕິທິນ — ສະຖານທີ່ / Partner ສັ້ນໆ */
export function formatClassSessionCalendarTitle(
  s: Pick<
    ClassSessionDTO,
    "templateName" | "locationKind" | "engagementKind" | "offSiteLabel"
  >,
): string {
  let title = s.templateName ?? "";
  if (s.locationKind === "off_site") {
    const place = s.offSiteLabel?.trim();
    title = place ? `${title} · ${place}` : `${title} · ນອກສະຖານທີ່`;
  }
  if (s.engagementKind === "partner_instructor_only") {
    title = `${title} · Partner`;
  }
  return title;
}

/** ປ້າຍສຳລັບຫົວຂໍ້ມູນ / ຕາຕະລາງ */
export function SessionEngagementBadges({
  session,
}: {
  session: Pick<ClassSessionDTO, "locationKind" | "engagementKind">;
}): ReactNode {
  const nodes: ReactNode[] = [];
  if (session.locationKind === "off_site") {
    nodes.push(
      <Badge key="off" variant="secondary">
        ນອກສະຖານທີ່
      </Badge>,
    );
  }
  if (session.engagementKind === "partner_instructor_only") {
    nodes.push(
      <Badge key="partner" variant="outline" className="border-foreground/30">
        Partner (instructor-only)
      </Badge>,
    );
  }
  if (nodes.length === 0) return null;
  return <span className="flex flex-wrap items-center gap-1.5">{nodes}</span>;
}
